"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
CartController.$inject = ['$scope', '_cart', '_profile', 'api', 'extApi', 'addresses', 'courierServices', 'cart', '$rootScope', '_analytics', 'notify', '_card'];
function CartController($scope, _cart, _profile, api, extApi, addresses, courierServices, cart, $rootScope, _analytics, notify, _card) {
    $scope.products = cart.items;
    $scope.addresses = addresses.data;
    $scope.courierServices = courierServices.data;
    $scope.total = 0;
    $scope.total_pdv = 0;
    $scope.subtotal = 0;
    $scope.has_error = false;
    $scope.saving = false;
    $scope.reservation = false;
    $scope.owe = 0;
    $scope.totalOrders = totalOrders($scope.products);
    $scope.completedOrderType = null;
    countTotalPrices();
    $scope.currency = $rootScope.currency;
    $rootScope.$watch('currency_value', function (value) {
        $scope.currency = $rootScope.currency_value;
    });
    $scope.show_vat = $rootScope.show_vat;
    $rootScope.$watch('show_vat', function (value) {
        $scope.show_vat = $rootScope.show_vat;
    });
    $scope.show_prices = $rootScope.show_prices;
    $rootScope.$watch('show_prices', function (value) {
        $scope.show_prices = $rootScope.show_prices;
    });
    _card.getFinanceSum(0).then(function (response) {
        $scope.owe = response.overdue_debt;
    }, function (error) {
    });
    //DEO ZA KORPU
    function countTotalPrices() {
        $scope.has_error = false;
        $scope.stock_error = false;
        $scope.price_error = false;
        $scope.total = $scope.total_pdv = $scope.subtotal = 0;
        lodash_1.default.each($scope.products, function (p, index) {
            p.price_show = p.quantity * p.price;
            $scope.total += p.price_show;
            p.vat_total = (p.price_show * p.vat) / 100;
            $scope.total_pdv += p.vat_total;
            p.subtotal = p.price_show + p.vat_total;
            $scope.subtotal += p.subtotal;
            if (p.error) {
                $scope.has_error = true;
                $scope.stock_error = true;
            }
            if (p.error_price) {
                $scope.has_error = true;
                $scope.price_error = true;
            }
        });
        _cart.setCartTotal($scope.total);
        _cart.setCartTotalVat($scope.subtotal);
        $scope.loading = false;
    }
    $scope.loading = false;
    $scope.addOne = function (product) {
        if (!$scope.loading) {
            // Disallow increasing quantity above 1 for damaged products (silently)
            if (product && product.damaged_product && product.quantity >= 1) {
                return;
            }
            if (product.quantity >= 10) {
                notify.error('Maksimalna dozvoljena količina je 10 komada.');
                return;
            }
            $scope.loading = true;
            _cart.update(product, { quantity: product.quantity + 1 }).then(function (response) {
                $scope.products = response.list.items;
                $scope.totalOrders = totalOrders($scope.products);
                countTotalPrices();
            }, function (error) {
                console.log('error');
                notify.error(error.data);
            });
        }
    };
    $scope.removeOne = function (product) {
        if (!$scope.loading) {
            $scope.loading = true;
            _cart.update(product, { quantity: product.quantity - 1 }).then(function (response) {
                $scope.products = response.list.items;
                $scope.totalOrders = totalOrders($scope.products);
                countTotalPrices();
                if (response.item.quantity == 0) {
                    addRemoveAnalytics(response.item);
                }
            }, function (error) {
                console.log('error');
            });
        }
    };
    $scope.remove = function (product) {
        if (!$scope.loading) {
            $scope.loading = true;
            _cart.remove(product).then(function (response) {
                $scope.products = response.items;
                $scope.totalOrders = totalOrders($scope.products);
                countTotalPrices();
                var productExists = response.items.find(function (item) { return item.product_id === product.product_id; });
                if (!productExists) {
                    addRemoveAnalytics({
                        _id: product.product_id,
                        name: product.name,
                        price: product.price
                    });
                }
            }, function (error) {
                $scope.errors = error.data;
            });
        }
    };
    $scope.fixPrice = function () {
        lodash_1.default.each($scope.products, function (product, key) {
            if (product.error_price) {
                _cart.update(product, { price: product.product_price })
                    .then(function (response) {
                    $scope.products = response.list.items;
                    $scope.totalOrders = totalOrders($scope.products);
                    countTotalPrices();
                }, function (error) {
                    console.log('error');
                });
            }
        });
    };
    function addRemoveAnalytics(product) {
        var normalizedPrice = product.price && product.price > 0 ? product.price : 0;
        var finalPrice = product.price_discount && (normalizedPrice === 0 || product.price_discount < normalizedPrice)
            ? product.price_discount
            : normalizedPrice;
        _analytics.removeFromCart({
            "id": product._id,
            "name": product.name,
            "quantity": 0,
            "price": finalPrice
        });
    }
    //DEO ZA PORUDZBINU
    $scope.minDate = new Date().toString();
    $scope.getMinDate = function () {
        return $scope.minDate;
    };
    $scope.delivery = [
        { name: 'Isporuka - redovna dostava', id: 'delivery' },
        { name: 'Preuzimanje', id: 'pickup' }
    ];
    var d = new Date();
    $scope.data = {
        date: (d.getDate() + 1) + '.' + (d.getMonth() + 1) + '.' + d.getFullYear(),
        remark: '',
        order_delivery: null,
        courier_service: null,
        address: null
    };
    $scope.order_ids = [];
    $scope.finishOrder = function () {
        var orderData = prepareOrderData();
        if (!orderData)
            return;
        orderData.reservation = false;
        saveOrder(orderData, true);
    };
    $scope.reserveOrder = function () {
        var orderData = prepareOrderData();
        if (!orderData)
            return;
        orderData.reservation = true;
        saveOrder(orderData);
    };
    function saveOrder(orderData, confirmation) {
        if (confirmation === void 0) { confirmation = false; }
        _cart.reserveModal(orderData, confirmation)
            .then(function (response) {
            // response.forEach(o => {
            // 	if (o && o.order_id) {
            // 		addPurchaseAnalytics(o.order_id);
            // 	}
            // });
            _cart.setCartTotal(0);
            _cart.setCartTotalVat(0);
            _cart.setCartSize(0);
            $scope.completedOrderType = orderData.reservation ? 'reservation' : 'order';
            $scope.order_ids = response.map(function (o) { return o.order_id; });
        }, function (error) {
            countTotalPrices();
            if (error.data) {
                if (error.data.error) {
                    if (error.data.error.details && error.data.error.details.locale) {
                        notify.error(error.data.error.details.locale.rs);
                    }
                    else {
                        notify.error(error.data.error.message);
                    }
                }
                else {
                    notify.error('Došlo je do greške prilikom obrade porudžbine. Pokušajte ponovo ili kontaktirajte prodavca.');
                }
            }
        });
    }
    function prepareOrderData() {
        if (!$scope.products.length) {
            alert('Korpa je prazna, dodajte proizvode');
            $scope.saving = false;
            $scope.reservation = false;
            return;
        }
        if ($scope.data.order_delivery.id === 'delivery') {
            if (!$scope.data.address) {
                alert('Molimo vas izaberite adresu za dostavu.');
                $scope.saving = false;
                $scope.reservation = false;
                return;
            }
        }
        if ($scope.data.order_delivery.id === 'pickup') {
            if (!$scope.data.ext_ref) {
                alert('Polje Referenca je obavezno u slučaju preuzimanja.');
                $scope.saving = false;
                $scope.reservation = false;
                return;
            }
        }
        var orderData = {
            fulfillment_type: $scope.data.order_delivery.id,
            delivery_address_id: $scope.data.address ? $scope.data.address.address_id : null,
            buyer_notes: $scope.data.remark ? $scope.data.remark : null,
            ext_ref: $scope.data.ext_ref ? $scope.data.ext_ref : null,
            courier_service_id: $scope.data.courier_service ? $scope.data.courier_service.id : null,
            items: $scope.products.map(function (p) {
                return {
                    product_id: p.product_id,
                    quantity: p.quantity
                };
            })
        };
        return orderData;
    }
    function addPurchaseAnalytics(_id) {
        var products = [];
        var position = 1;
        lodash_1.default.each($scope.products, function (p, index) {
            products.push({
                "id": p.product_id,
                "name": p.name,
                "list_position": position,
                "quantity": p.quantity,
                "price": p.price
            });
            position++;
        });
        _analytics.purchase({
            "transaction_id": _id,
            "value": $scope.subtotal,
            "currency": 'RSD',
            "items": products
        });
    }
    //Datepicker - icon - open
    $(document).on("click", function () {
        if (!angular.element(document.querySelector('.datepciker')).find(event.target)[0]
            && !angular.element(document.querySelector('#calendar')).find(event.target)[0]) {
            $("._720kb-datepicker-calendar").removeClass('_720kb-datepicker-open');
        }
    });
    $(document).on("click", ".material-icons.calendar", function () {
        $("#dateInput").trigger("click");
    });
    //New address
    $scope.addAddress = function () {
        _profile.addAddressModal().then(function (response) {
            $scope.addresses.push(response);
            $scope.data.address = response;
        }, function (error) {
            console.log('error');
        });
    };
    //ZA MOBILNI
    $scope.step1 = true;
    $scope.changeStep = function () {
        $scope.step1 = !$scope.step1;
    };
    function totalOrders(products) {
        var result = [];
        var currentOrder = [];
        var currentCodes = [];
        for (var i = 0; i < products.length; i++) {
            var product = products[i];
            var code = product._ext_sifra;
            if (currentCodes.indexOf(code) !== -1) {
                if (currentOrder.length > 0) {
                    result.push(currentOrder);
                }
                currentOrder = [];
                currentCodes = [];
            }
            if (product.damaged_product === 0) {
                currentOrder.unshift(product);
            }
            else {
                currentOrder.push(product);
            }
            currentCodes.push(code);
        }
        if (currentOrder.length > 0) {
            result.push(currentOrder);
        }
        return result.length;
    }
}
exports.CartController = CartController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/cart/controllers/CartController.js
// module id = 424
// module chunks = 0